/** 탐색_맵 공통 view model 타입 (검색·필터는 HomeSpaceExplorer variant="map"과 동일) */

export type ExploreMapListItem = {
  availableRoomCount?: number;
  bookmarkSaved: boolean;
  detailPath: string;
  externalPlaceId?: string | null;
  image: string;
  latitude?: number;
  location: string;
  longitude?: number;
  priceLabel: string;
  priceSuffix: string;
  rating: string;
  registrationRequestCount?: number | null;
  registrationStatus?: 'REGISTERED' | 'UNREGISTERED' | string | null;
  requestable?: boolean | null;
  spaceType: string;
  studio: string;
  tags: [string, string];
  title: string;
};

export type ExploreMapPopularVendor = {
  avatarStyle: string;
  label: string;
  slug: string;
};

export type ExploreMapMarker = {
  availableRoomCount?: number;
  externalPlaceId?: string | null;
  location?: string;
  detailPath: string;
  lat: number;
  lng: number;
  pinStyle?: 'active' | 'default';
  registrationRequestCount?: number | null;
  registrationStatus?: 'REGISTERED' | 'UNREGISTERED' | string | null;
  requestable?: boolean | null;
  title: string;
};

/** 홍대·합정 인근 중심 좌표 */
export const EXPLORE_MAP_CENTER = {
  lat: 37.5537,
  lng: 126.9233,
} as const;
